import React from 'react';
import {
  Col,
  Container,
  Row,
  Spinner,
} from 'react-bootstrap';

import '../../assets/styles/Dashboard.css';

import useDashboardData from './hooks/useDashboardData';
import DashboardStatisticCardGroup from './components/DashboardStatisticCardGroup';
import DashboardSalesSection from './components/DashboardSalesSection';
import DashboardLatestBookingsTable from './components/DashboardLatestBookingsTable';
import DashboardLatestRequestsTable from './components/DashboardLatestRequestsTable';

import useCompanyContext from '../../hooks/useCompanyContext';

function DashboardPage() {
  const {
    currentCompanyID,
    hasSpecificCompany,
  } = useCompanyContext();

  /**
   * Dashboard API 当前约定：
   *
   * 0    => 全部公司
   * UUID => 指定公司
   */
  const supplierId =
    hasSpecificCompany
      ? String(currentCompanyID)
      : '0';

  const {
    loading,
    stats,
    latestBookings,
    latestRequests,
    salesChartData,
    worldSalesData,
  } = useDashboardData({
    supplierId,
  });

  return (
    <Container
      fluid
      className="d-flex flex-column"
    >
      <Row className="mb-4">
        <Col sm={12}>
          <span className="fw-semibold">
            Dashboard
          </span>
        </Col>
      </Row>

      {loading ? (
        <div className="py-5 text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <DashboardStatisticCardGroup
            stats={stats}
          />

          <DashboardSalesSection
            salesChartData={
              salesChartData
            }
            worldSalesData={
              worldSalesData
            }
            currencyCode="usd"
          />


          <Row className="mt-4">
            <Col
              xs={12}
              md={6}
              lg={6}
            >
              <DashboardLatestBookingsTable
                data={latestBookings}
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={6}
            >
              <DashboardLatestRequestsTable
                data={latestRequests}
              />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}

export default DashboardPage;